import { OvalLoader, SmartForm } from "@avenueops/web-components";
import { useFormContext, useWatch } from "react-hook-form";
import { trpc2 } from "utils/trpc";

interface Props {
  connectionId: string;
  prefix?: string;
}

export function TableauQueryMeta({ connectionId, prefix = "queryMeta" }: Props) {
  const { data: workbookOptions, isLoading: isLoadingWorkbooks } = trpc2.v2.databaseConnections.listTableauWorkbooks.useQuery({
    connectionId,
  });
  const workbookid = useWatch({ name: "queryMeta.workbook.id" });
  const { data: viewOptions, isLoading: isLoadingViews } = trpc2.v2.databaseConnections.listTableauViews.useQuery(
    {
      connectionId,
      workbookId: workbookid,
    },
    {
      enabled: !!workbookid,
    },
  );
  const { setValue, register } = useFormContext();

  return (
    <div className="flex min-w-300 gap-2" key={`${connectionId}_${prefix}`}>
      {!isLoadingWorkbooks ? (
        <div className="flex-1">
          <SmartForm.DropdownSelect
            name={`${prefix}.workbook.id`}
            title="Tableau Workbook"
            options={
              workbookOptions?.map((workbook) => ({
                label: workbook.name,
                value: workbook.id,
              })) ?? []
            }
            onChangeCallback={(value, options) => {
              if (value) {
                setValue(`${prefix}.workbook.name`, options?.[0].label);
              } else {
                setValue(`${prefix}.workbook.name`, null);
              }
              setValue(`${prefix}.view.id`, null);
              setValue(`${prefix}..view.name`, null);
            }}
          />
        </div>
      ) : (
        <div className="flex-1 flex items-center justify-center">
          <OvalLoader size={25} />
        </div>
      )}
      {!isLoadingViews || !workbookid ? (
        <div className="flex-1">
          <SmartForm.DropdownSelect
            name={`${prefix}.view.id`}
            title="Tableau View"
            options={
              viewOptions?.map((view) => ({
                label: view.name,
                value: view.id,
              })) ?? []
            }
            disabled={!workbookid}
            onChangeCallback={(value, options) => {
              if (value) {
                setValue(`${prefix}.view.name`, options?.[0]!.label);
              } else {
                setValue(`${prefix}.view.name`, null);
              }
            }}
          />
        </div>
      ) : (
        <div className="flex-1 flex items-center justify-center">
          <OvalLoader size={25} />
        </div>
      )}
    </div>
  );
}
